let initialized = false;

const favicon = () => {
    if (initialized) return;
    initialized = true;

    const link = document.querySelector('link[rel="icon"]') || document.createElement('link');

    // Keep a stable URL so the browser can cache the favicon.
    link.rel = 'icon';
    link.type = 'image/svg+xml';
    link.href = '/wp-content/themes/hokra-freshlemon/public/gfx/favicon/favicon-1.svg';

    if (!link.isConnected) document.head.appendChild(link);
};

export { favicon };
